import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';
import componentStyles from './pc-people-bio-hero.css.lit';

import '../pc-container/pc-container';
import globalStyles from './pc-people-bio-hero.lightDom.css.lit';
import '../pc-animation/pc-animation';

/**
 * People Bio Hero component
 * @element pc-people-bio-hero
 * @slot - This element has a default slot
 */
@customElement('pc-people-bio-hero')
export class PCPeopleBioHero extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];
  adoptedStylesheets: AdoptedStyleSheets;

  /**
   * When loaded
   */
  @property({ type: String, reflect: true })
  loaded: string;

  @property({ type: Boolean, reflect: true, attribute: 'has-image' })
  hasImage: boolean;

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
    this.hasImage = Boolean(this.querySelector('[slot="image"]'));
  }

  firstUpdated() {
    this.loaded = 'true';
  }

  render(): TemplateResult {
    return html`
      <div class="hero ${!this.hasImage ? 'without-image' : null}">
        <pc-container>
          <slot name="nav"></slot>

          <div class="container">
            <div class="left-side">
              <slot name="image"></slot>
            </div>
            <div class="right-side">
              <slot name="info"></slot>
              <slot name="contact"></slot>
            </div>
          </div>
        </pc-container>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-people-bio-hero': PCPeopleBioHero;
  }
}
